export default [
  {
    path: '/client/dados',
    name: 'clients-data',
    meta: { valid: "login" },
    component: () => import('../../views/client/ClientData.vue')
  },  
  {
    path: '/cliente/enderecos',
    name: 'clients-address',
    component: () => import('../../views/client/ClientAddress.vue')
  },  
  {
    path: '/cliente/cartoes',
    name: 'clients-cards',
    component: () => import('../../views/client/ClientCards.vue')
  },  
  {
    path: '/novo/cartao',
    name: 'new-card',
    component: () => import('../../views/client/NewCards.vue')
  },  
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('../../views/notification/Index.vue')
  }, 
  {
    path: '/client/wallet',
    name: 'clients-wallet',
    component: () => import('../../views/client/Wallet.vue')
  }, 
];
